import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faServer, 
  faChartLine, 
  faShieldAlt, 
  faClock,
  faUsers,
  faGlobe,
  faTruck,
  faArrowRight,
  faStar,
  faUser,
  faPhone,
  faEnvelope,
  faBuilding,
  faPaperPlane,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import FeaturesSection from '../components/FeaturesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import DemoModal from '../components/DemoModal';
import CompanyInfo from '../components/CompanyInfo';

const Home = ({ onPurchaseClick }) => {
  const homeRef = useRef(null);
  const contactSectionRef = useRef(null);
  

  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  
  // 滚动到联系区域的函数
  const scrollToContact = () => {
    const contactSection = document.querySelector('[data-contact-section]');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  useEffect(() => {
    // 页面加载动画
    gsap.fromTo(
      homeRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.8, ease: 'power2.out' }
    );
  }, []);
  


  return (
    <div ref={homeRef} className="min-h-screen">
      {/* 英雄区域 */}
      <HeroSection onDemoClick={scrollToContact} onPurchaseClick={onPurchaseClick} />
      
      {/* 数据统计区域 */}
      <StatsSection />
      
      {/* 产品功能区域 */}
      <FeaturesSection onDemoClick={() => setIsDemoModalOpen(true)} />
      
      {/* 客户案例区域 */}
      <TestimonialsSection />
      
      {/* 联系我们区域 */}
      <section ref={contactSectionRef} data-contact-section className="py-20 bg-background-light">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold gradient-text mb-6">
                联系我们
              </h2>
              <p className="text-xl text-gray-600">
                专业的财务解决方案，贴心的一对一服务
              </p>
            </div>
            
            <CompanyInfo 
              title="联系我们" 
              description="扫描二维码添加销售微信，获取专业财务咨询服务" 
            />
          </div>
        </div>
      </section>
      
      {/* CTA区域 */}
      <section className="py-20 bg-gradient-primary">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              准备好开始您的智能财务之旅了吗？
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              立即体验云帐天下智能财务系统，让您的财务管理更加高效、准确、智能
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={onPurchaseClick}
                className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-4 rounded-lg font-semibold hover:from-orange-600 hover:to-red-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                立即购买
              </button>
              <button 
                onClick={() => setIsDemoModalOpen(true)}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary-dark transition-all duration-300"
              >
                预约演示
              </button>
            </div>
          </div>
        </div>
      </section>
      
      {/* 演示预约弹窗 */}
      <DemoModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      />
    </div>
  );
};

export default Home;